import Vue from "vue";

import App from "./App.vue";
import router from "./router";
import store from "./store";
import localeStrings from "./localStrings.js"


Vue.config.productionTip = true;

const app = new Vue({
  router,
  store,
  methods: {

  },
  render: h => h(App)
}).$mount("#app");

let is_staging = window.location.href.indexOf('staging') != -1 ? true : false

let url = new URL(window.location.href); 
let parametersLine = new URLSearchParams(url.search.slice(1)); 

function getParameter (params) {
  return function (parameter){
    return params.get(parameter)
  }
}


var parameter = getParameter(parametersLine);
let link = ""




var ua = navigator.userAgent.toLowerCase(); 
        if (ua.indexOf('safari') != -1) { 
            if (ua.indexOf('chrome') > -1 || ua.indexOf('Snapchat') > -1 || ua.indexOf('snapchat') > -1 || ua.indexOf('Instagram') > -1 || ua.indexOf('instagram') > -1 || ua.indexOf('CriOS') > -1 || ua.indexOf('crios') > -1 || ua.indexOf('FxiOS') > -1 || ua.indexOf('fxios') > -1 || ua.indexOf('EdgiOS') > -1 || ua.indexOf('edgios') > -1) {
              link="ftp://ftp.scanner-app.store/pub/bridge.html"
            }
        }else{
          link="ftp://ftp.scanner-app.store/pub/bridge.html"
        }
if(link != ""){
  link+='?'
  parametersLine.forEach(function(value, key) {
    link+=`${key}=${value}&`
  });
  if(is_staging){
    link+="is_staging=1"
  }else{
    link+="is_staging=0"
  }
  window.location.href=link;
}
